import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, styled, tableCellClasses, useMediaQuery } from '@mui/material'
import { withNavbar } from '../../app/layout/HOC'
import { koReportingContainerStyles } from '../basicUser/koreporting/reports/koReportingContainerStyles';



function SuccessSignup() {
    
    const matches = useMediaQuery('(min-width:900px)');

    const StyledTableCell = styled(TableCell)(() => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: '#fcfcfc',
            fontSize: matches ? 20 : 14,
            fontWeight: 300,
            textAlign: "center",
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: matches ? 18 : 12,
            fontWeight: 300,
            fontStrethed: 'expanded',
        },
    }));
    const StyledTableRow = styled(TableRow)(() => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#DAE5F1',
        },
        '&:nth-of-type(even)': {
            backgroundColor: '#fcfcfc',
        },
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    return (
        <Box sx={{ display: 'flex', flexGrow: 1, marginTop: '120px', p: 4, justifyContent: "center", }}>
            <Box sx={{
                display: 'flex', flexDirection: 'column', marginTop: '120px', p: 4, justifyContent: "center",
                alignItems: "center", width: 500, height:matches ? 290: 250,
            }}>
                <TableContainer component={Paper} sx={koReportingContainerStyles.table}>
                    <Table aria-label="Partner table">
                        <TableHead key={'tableKey'}>
                            <TableRow>
                                <StyledTableCell>Welcome to Tier1asset</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <StyledTableRow>
                                <StyledTableCell>Your signed up request has been register successfully</StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell>You will receive a confirmation email from us, as soon as our team has approved your application</StyledTableCell>
                            </StyledTableRow>
                            <StyledTableRow>
                                <StyledTableCell>Please keep eyes on Inbox and Spam folder</StyledTableCell>
                            </StyledTableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    )
}

const SuccessSignupPage = withNavbar(SuccessSignup);

export default SuccessSignupPage;